import jsSHA from "jssha";

var sha1 = require('sha1');

export const roleUser = [
    {
        _id: 0,
        role: "Family",
        code: "1984",
        email: `${process.env.REACT_APP_EMAIL_PRINCIPAL}`
    },
    {
        _id: 1,
        role: "Administrator",
        code: "1986"
    },
     {
        _id: 2,
        role: "SellerAdmin",
        code: "2015"
    },
    {
        _id: 3,
        role: "Provider",
        code: "2014"
    },
    {
        _id: 4,
        role: "Seller",
        code: "2010"
    },
    {
        _id: 5,
        role: "Royalty",
        code: "2011"
    },  
    {
        _id: 6,
        role: "Associate",
        code: "2018"
    }, 
    {
        _id: 7,
        role: "Investment",
        code: "2022"
    }
];

// Mirrors elakay_services/roleActivation.js's ROLE_CONFIG exactly (same
// code/level per role) -- the single source of truth for "which team-managing
// level a role sits at" on the frontend, used by addAdminFamily.jsx's own
// inline roleI values (Royalty:1..Family:7) and by anything that needs to
// edit an EXISTING member's role limits (e.g. CardUser's activation modal)
// without re-running the "add a new role" flow. Never redefine these
// codes/levels a second time elsewhere -- a mismatch with the backend table
// silently breaks computeRoleHash below.
export const ROLE_CAPACITY_CONFIG = {
    Royalty: { code: "2011", level: 1 },
    Seller: { code: "2010", level: 2 },
    Provider: { code: "2014", level: 3 },
    Associate: { code: "2018", level: 4 },
    Investment: { code: "2022", level: 5 },
    Administrator: { code: "1986", level: 6 },
    Family: { code: "1984", level: 7 },
};

// Same SHA-1 + HMAC-SHA512 hash addAdminFamily.jsx computes inline per role
// branch (selectedUser()) when ADDING a role, and the one
// elakay_services/roleActivation.js's roleHash() computes server-side when a
// pending proposal is accepted (UpdateUserRoleTrue copies this value
// verbatim onto the live userActiveRole.role). Always keyed on the TARGET
// user's own _id -- never the acting admin's -- matching both of those. A
// wrong hash here doesn't error immediately; it silently breaks Family()/
// Adminstrator()/Investment()/Assoociate()/Provider()/Seller()/Customer() in
// Rolle.js for that user the moment they accept the proposal.
export const computeRoleHash = (roleName, targetUserId) => {
    const config = ROLE_CAPACITY_CONFIG[roleName];
    if (!config || !targetUserId) return "";
    const kay = sha1(config.code) + sha1(roleName) + sha1(targetUserId);
    const shaObj = new jsSHA("SHA-512", "TEXT", {
        hmacKey: { value: kay, format: "TEXT" },
    });
    shaObj.update(kay);
    return shaObj.getHash("HEX");
};